import tariff from '@/store/modules/tariff/tariff'
import tariffList from '@/store/modules/tariff/tariff-list'
import tariffCrate from '@/store/modules/tariff/tariff-create'
import tariffDelete from '@/store/modules/tariff/tariff-delete'

export default {
  tariff,
  tariffList,
  tariffCrate,
  tariffDelete
}
